module.exports = __webpack_public_path__ + "img/messanger.2e9f8510.svg";